export default __webpack_public_path__ + "static/media/sus2.d70d5e47.jpg";